/**
 * YTRE card draft cache (Sep 30, 2026 — Randy: "it was a work in progress and
 * had not been submitted yet … not only was it not saved").
 *
 * A card's Edit box is React state: a tab switch, a route change or a power cut
 * takes it with it. The session, the transcript and any generated response are
 * server rows and survive — this mirrors the ONLY thing that didn't.
 *
 * Deliberately local: an unsaved edit is not a fact about the silo yet, so it
 * must never reach the DB and never sync across devices. It expires so an
 * abandoned keystroke can't reappear a year later pretending to be work.
 */
const PREFIX = "mysilo_ytre_draft:";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const MAX_CHARS = 200_000;

const key = (id) => `${PREFIX}${id}`;

export function readDraft(id) {
  if (!id) return null;
  try {
    const raw = window.localStorage.getItem(key(id));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.text) return null;
    if (parsed.at && Date.now() - parsed.at > MAX_AGE_MS) {
      window.localStorage.removeItem(key(id));
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeDraft(id, text, field) {
  if (!id) return;
  try {
    if (!text || text.length > MAX_CHARS) {
      window.localStorage.removeItem(key(id));
      return;
    }
    window.localStorage.setItem(key(id), JSON.stringify({ text, field, at: Date.now() }));
  } catch {
    /* quota or private mode — autosave is a courtesy, never a blocker */
  }
}

export function clearDraft(id) {
  if (!id) return;
  try { window.localStorage.removeItem(key(id)); } catch { /* ignore */ }
}

/** How long ago the recovered draft was typed, for the banner. */
export function draftAgeLabel(at) {
  if (!at) return "";
  const mins = Math.max(0, Math.round((Date.now() - at) / 60000));
  if (mins < 1) return "seconds ago";
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs === 1 ? "" : "s"} ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}
